/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import App from '../containers/App/App';
import {HomeRoutes} from './HomeRoutes';
import {AppsRoutes} from './AppsRoutes';
import {LearnRoutes} from './LearnRoutes';
import {SearchRoutes} from './SearchRoutes';
import {ErrorRoutes} from './ErrorRoutes';
import {GrowthRoutes} from './GrowthRoutes';
import {DiscoverRoutes} from './DiscoverRoutes';
import {LibrariesRoutes} from './LibrariesRoutes';
import {AppHomeRoutes} from './AppHomeRoutes';

export default [
	{
		...App,
		routes: [
			...HomeRoutes,
			...AppHomeRoutes,
			...LearnRoutes,
			...AppsRoutes,
			...LibrariesRoutes,
			...SearchRoutes,
			...GrowthRoutes,
			...DiscoverRoutes,
			...ErrorRoutes,
		],
	},
];
